import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { PdpRespTitle } from '../../PdpRespTitle/PdpRespTitle';

// types
import { type PdpRespSharedTitle_item$key as Item } from './__generated__/PdpRespSharedTitle_item.graphql';

const itemQuery = graphql`
    fragment PdpRespSharedTitle_item on Item {
        ...PdpRespTitle_item
    }
`;
export const PdpRespSharedTitle: FC<{ item: Item; isSoldPDPV3Variant?: boolean | null }> = ({
    item: itemRef,
    isSoldPDPV3Variant = false,
}) => {
    const item = useFragment(itemQuery, itemRef);

    return <PdpRespTitle item={item} isSoldPDPV3Variant={isSoldPDPV3Variant} />;
};
